"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.track = exports.page = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
var reject_1 = tslib_1.__importDefault(require("ramda/src/reject"));
var PAGE_QUERY = graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query AnalyticsPage($input: AnalyticsPageInput) {\n    analyticsPage(input: $input) {\n      success\n    }\n  }\n"], ["\n  query AnalyticsPage($input: AnalyticsPageInput) {\n    analyticsPage(input: $input) {\n      success\n    }\n  }\n"])));
var TRACK_QUERY = graphql_tag_1.default(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  query AnalyticsTrack($input: AnalyticsTrackInput) {\n    analyticsTrack(input: $input) {\n      success\n    }\n  }\n"], ["\n  query AnalyticsTrack($input: AnalyticsTrackInput) {\n    analyticsTrack(input: $input) {\n      success\n    }\n  }\n"])));
var reject = reject_1.default(function (v) { return v === undefined; });
function page(data, config) {
    var url = data.url, href = data.href, input = tslib_1.__rest(data, ["url", "href"]);
    return config.apolloClient.query({
        query: PAGE_QUERY,
        variables: {
            input: reject(tslib_1.__assign({ href: href || url }, input))
        }
    });
}
exports.page = page;
function track(data, config) {
    var hitType = data.hitType, event = data.event, label = data.label, category = data.category, campaign = data.campaign, others = tslib_1.__rest(data, ["hitType", "event", "label", "category", "campaign"]);
    var custom = Object.keys(others) ? others : undefined;
    return config.apolloClient.query({
        query: TRACK_QUERY,
        variables: {
            input: reject({
                hitType: hitType,
                event: event,
                label: label,
                category: category,
                campaign: campaign,
                custom: custom
            })
        }
    });
}
exports.track = track;
function catalytic(userConfig) {
    return {
        name: 'catalytic',
        config: {
            apolloClient: userConfig.apolloClient
        },
        page: function (_a) {
            var config = _a.config, payload = _a.payload;
            var properties = payload.properties;
            page(properties, config);
        },
        track: function (_a) {
            var config = _a.config, payload = _a.payload;
            var event = payload.event, properties = payload.properties;
            track(tslib_1.__assign({ event: event }, properties), config);
        },
        loaded: function () { return true; }
    };
}
exports.default = catalytic;
var templateObject_1, templateObject_2;
//# sourceMappingURL=catalytic.js.map